import React from 'react';
import BrochereContainer from './styles';
import { Typography, Grid, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Animation from '../../../../components/Animation';
import LabelTitle from '../../../../components/Titles/LabelTitle';
import { Button } from '../../../../components/Buttons';

/* PDF */
import BrochurePdfES from '../../../../assets/pdf/es/brochure.pdf';
import BrochurePdfEN from '../../../../assets/pdf/en/brochure.pdf';

const DownloadButton = () => {
	const { t, i18n } = useTranslation();
	return (
		<a
			href={i18n.language === 'es' ? BrochurePdfES : BrochurePdfEN}
			style={{ textDecoration: 'none' }}
			role="button"
			download="brochure"
		>
			<Button
				content={t('general.actions.download')}
				variant={'outlined'}
				color={'primary'}
				textColor={'#0392ce'}
			/>
		</a>
	);
};

const Brochure = () => {
	const { t } = useTranslation();

	return (
		<BrochereContainer>
			<Grid container alignItems="center">
				<Grid item xs={12} sm={6} className="brochure__image">
					<div className="brochure__image" />
				</Grid>
				<Grid item xs={12} sm={6} className="brochure__data">
					<Animation animateIn="fadeInRight">
						<Box mb={3}>
							<LabelTitle content={t('general.brochure.label')} />
							<Typography variant="h2" color="textSecondary">
								{t('general.brochure.title')}
							</Typography>
						</Box>
						<Box display={{ xs: 'none', sm: 'inline' }}>
							<DownloadButton />
						</Box>
					</Animation>
				</Grid>
			</Grid>
			<Box mr={1.5} display={{ xs: 'inline', sm: 'none' }}>
				<Grid container justify="center">
					<DownloadButton />
				</Grid>
			</Box>
		</BrochereContainer>
	);
};

export default Brochure;
